// TODO: (MVP-1132): these types should be generated automatically based on the API's Swagger documentation

import { UnitEnum } from './units';

export type IndicatorFactType = string;

export enum IndicatorName {
  // HACK - with custom widgets, facts that dont have a fact type defined in BE can be passed
  // use "unknown" as a placeholder type for them.
  unknown = 'unknown',

  // --------------------------------------- MAP-LAYERS
  // cckp
  annual_surface_air_temperature = 'annual_surface_air_temperature',
  annual_precipitation = 'annual_precipitation',

  // soil grids
  ocs_0_30cm_mean = 'ocs_0_30cm_mean',
  sand_0_5cm_mean = 'sand_0_5cm_mean',
  cec_0_5cm_mean = 'cec_0_5cm_mean',
  nitrogen_0_5cm_mean = 'nitrogen_0_5cm_mean',

  // landscape
  gbif_species_occurrence = 'gbif_species_occurrence',

  // --------------------------------------- MONETARY-RISK
  // current
  ecosystem_integrity_index = 'ecosystem_integrity_index',
  ecological_integrity_score = 'ecological_integrity_score',
  compositional_integrity_score = 'compositional_integrity_score',
  functional_integrity_score = 'functional_integrity_score',

  stewarded_value = 'stewarded_value',

  // misc
  ecosystem_integrity_index_benchmark = 'ecosystem_integrity_index_benchmark',

  // --------------------------------------- SOCIAL
  // current
  social_life_expectancy = 'social_life_expectancy',

  // misc
  social_life_expectancy_max = 'social_life_expectancy_max',
  social_life_expectancy_min = 'social_life_expectancy_min',

  // historic
  social_life_expectancy_previous_5y_pct_change = 'social_life_expectancy_previous_5y_pct_change',
  social_life_expectancy_previous_1y_pct_change = 'social_life_expectancy_previous_1y_pct_change',
  social_life_expectancy_previous_5y_avg_uplift = 'social_life_expectancy_previous_5y_avg_uplift',
  social_life_expectancy_previous_1y_uplift = 'social_life_expectancy_previous_1y_uplift',

  // --------------------------------------- PROTECTED ON-FARM HABITAT

  // misc
  biodiversity_buffer_zone_pct_benchmark_graph = 'biodiversity_buffer_zone_pct_benchmark_graph',

  // historic
  biodiversity_buffer_zone_pct_historic_graph = 'biodiversity_buffer_zone_pct_historic_graph',

  biodiversity_buffer_zone_pct_previous_1y_uplift_pct_change = 'biodiversity_buffer_zone_pct_previous_1y_uplift_pct_change',
  biodiversity_buffer_zone_pct_previous_1y_uplift_change = 'biodiversity_buffer_zone_pct_previous_1y_uplift_change',
  biodiversity_buffer_zone_pct_previous_5y_uplift = 'biodiversity_buffer_zone_pct_previous_5y_uplift',
  biodiversity_buffer_zone_pct_previous_5y_pct_change = 'biodiversity_buffer_zone_pct_previous_5y_pct_change',
  biodiversity_buffer_zone_pct_previous_1y_pct_change = 'biodiversity_buffer_zone_pct_previous_1y_pct_change',

  // current
  biodiversity_buffer_zone_pct = 'biodiversity_buffer_zone_pct',

  // --------------------------------------- DEFORESTATION

  // current
  deforestation_total = 'deforestation_total',
  deforestation_driver_percentage = 'deforestation_driver_percentage',

  // historic
  deforestation_previous_5y_uplift = 'deforestation_previous_5y_uplift',
  deforestation_previous_1y_pct_change = 'deforestation_previous_1y_pct_change',

  deforestation_total_historic_graph = 'deforestation_total_historic_graph',
  deforestation_total_previous_1y_uplift = 'deforestation_total_previous_1y_uplift',

  // misc
  deforestation_total_benchmark_graph = 'deforestation_total_benchmark_graph',

  // --------------------------------------- FOREST INTELLIGENCE

  // current
  forest_intelligence_sla_percentile = 'forest_intelligence_sla_percentile',
  forest_intelligence_sla_comparison = 'forest_intelligence_sla_comparison',
  forest_intelligence_lnc_percentile = 'forest_intelligence_lnc_percentile',
  forest_intelligence_lnc_comparison = 'forest_intelligence_lnc_comparison',
  forest_intelligence_lpc_percentile = 'forest_intelligence_lpc_percentile',
  forest_intelligence_lpc_comparison = 'forest_intelligence_lpc_comparison',
  forest_intelligence_functional_diversity_percentile = 'forest_intelligence_functional_diversity_percentile',
  forest_intelligence_functional_diversity_comparison = 'forest_intelligence_functional_diversity_comparison',
  forest_intelligence_ecoregion_id = 'forest_intelligence_ecoregion_id',
  forest_intelligence_ecoregion_graph = 'forest_intelligence_ecoregion_graph',
  // --------------------------------------- LAND SURFACE TEMPERATURE

  // current
  lst = 'lst',
  lst_normal = 'lst_normal',
  lst_forecast = 'lst_forecast',
  lst_benchmark = 'lst_benchmark',

  // historic
  lst_previous_1y_uplift = 'lst_previous_1y_uplift',
  lst_previous_1y_pct_change = 'lst_previous_1y_pct_change',

  lst_historic_graph = 'lst_historic_graph',
  lst_forecast_graph = 'lst_forecast_graph',
  lst_benchmark_graph = 'lst_benchmark_graph',

  // --------------------------------------- CARBON (BGC + AGC)

  // current
  carbon_combined_per_ha = 'carbon_combined_per_ha',

  // historic
  carbon_combined_previous_5y_avg_uplift = 'carbon_combined_previous_5y_avg_uplift',
  carbon_combined_previous_5y_pct_change = 'carbon_combined_previous_5y_pct_change',
  carbon_combined_previous_1y_uplift = 'carbon_combined_previous_1y_uplift',
  carbon_combined_previous_1y_pct_change = 'carbon_combined_previous_1y_pct_change',

  // --------------------------------------- BELOW GROUND CARBON

  // misc
  permanent_soil_carbon_total_benchmark = 'permanent_soil_carbon_total_benchmark',
  permanent_soil_carbon_per_ha_benchmark = 'permanent_soil_carbon_per_ha_benchmark',

  permanent_soil_co2_equivalent_total = 'permanent_soil_co2_equivalent_total',
  permanent_soil_co2_equivalent_per_ha = 'permanent_soil_co2_equivalent_per_ha',

  // historic
  soil_carbon_historic_total_graph = 'soil_carbon_historic_total_graph',
  soil_carbon_historic_per_ha_graph = 'soil_carbon_historic_per_ha_graph',

  permanent_soil_carbon_previous_1y_uplift_total = 'permanent_soil_carbon_previous_1y_uplift_total',
  permanent_soil_carbon_previous_1y_uplift_per_ha = 'permanent_soil_carbon_previous_1y_uplift_per_ha',

  permanent_soil_carbon_previous_1y_uplift_total_pct_change = 'permanent_soil_carbon_previous_1y_uplift_total_pct_change',
  permanent_soil_carbon_previous_1y_uplift_per_ha_pct_change = 'permanent_soil_carbon_previous_1y_uplift_per_ha_pct_change',

  permanent_soil_carbon_total_previous_5y_avg_uplift = 'permanent_soil_carbon_total_previous_5y_avg_uplift',
  permanent_soil_carbon_per_ha_previous_5y_avg_uplift = 'permanent_soil_carbon_per_ha_previous_5y_avg_uplift',
  permanent_soil_carbon_per_ha_previous_5y_uplift = 'permanent_soil_carbon_per_ha_previous_5y_uplift',

  // current
  permanent_soil_carbon_total = 'permanent_soil_carbon_total',
  permanent_soil_carbon_per_ha = 'permanent_soil_carbon_per_ha',

  // projection
  permanent_soil_carbon_uplift_potential_total_graph = 'permanent_soil_carbon_uplift_potential_total_graph',
  permanent_soil_carbon_uplift_potential_per_ha_graph = 'permanent_soil_carbon_uplift_potential_per_ha_graph',

  permanent_soil_carbon_1y_uplift_potential_total_change = 'permanent_soil_carbon_1y_uplift_potential_total_change',
  permanent_soil_carbon_1y_uplift_potential_per_ha_change = 'permanent_soil_carbon_1y_uplift_potential_per_ha_change',

  permanent_soil_carbon_1y_uplift_potential_total_pct_change = 'permanent_soil_carbon_1y_uplift_potential_total_pct_change',
  permanent_soil_carbon_1y_uplift_potential_per_ha_pct_change = 'permanent_soil_carbon_1y_uplift_potential_per_ha_pct_change',

  permanent_soil_carbon_5y_uplift_potential_total_change = 'permanent_soil_carbon_5y_uplift_potential_total_change',
  permanent_soil_carbon_5y_uplift_potential_per_ha_change = 'permanent_soil_carbon_5y_uplift_potential_per_ha_change',

  permanent_soil_carbon_5y_uplift_potential_total_pct_change = 'permanent_soil_carbon_5y_uplift_potential_total_pct_change',
  permanent_soil_carbon_5y_uplift_potential_per_ha_pct_change = 'permanent_soil_carbon_5y_uplift_potential_per_ha_pct_change',

  permanent_soil_carbon_per_ha_previous_5y_pct_change = 'permanent_soil_carbon_per_ha_previous_5y_pct_change',
  permanent_soil_carbon_per_ha_previous_1y_pct_change = 'permanent_soil_carbon_per_ha_previous_1y_pct_change',

  permanent_soil_carbon_total_5y_avg_uplift = 'permanent_soil_carbon_total_5y_avg_uplift',
  permanent_soil_carbon_per_ha_5y_avg_uplift = 'permanent_soil_carbon_per_ha_5y_avg_uplift',

  permanent_soil_carbon_10y_uplift_potential_total_change = 'permanent_soil_carbon_10y_uplift_potential_total_change',
  permanent_soil_carbon_10y_uplift_potential_per_ha_change = 'permanent_soil_carbon_10y_uplift_potential_per_ha_change',

  permanent_soil_carbon_10y_uplift_potential_total_pct_change = 'permanent_soil_carbon_10y_uplift_potential_total_pct_change',
  permanent_soil_carbon_10y_uplift_potential_per_ha_pct_change = 'permanent_soil_carbon_10y_uplift_potential_per_ha_pct_change',

  permanent_soil_carbon_total_10y_avg_uplift = 'permanent_soil_carbon_total_10y_avg_uplift',
  permanent_soil_carbon_per_ha_10y_avg_uplift = 'permanent_soil_carbon_per_ha_10y_avg_uplift',

  permanent_soil_carbon_20y_uplift_potential_total_change = 'permanent_soil_carbon_20y_uplift_potential_total_change',
  permanent_soil_carbon_20y_uplift_potential_per_ha_change = 'permanent_soil_carbon_20y_uplift_potential_per_ha_change',

  permanent_soil_carbon_20y_uplift_potential_total_pct_change = 'permanent_soil_carbon_20y_uplift_potential_total_pct_change',
  permanent_soil_carbon_20y_uplift_potential_per_ha_pct_change = 'permanent_soil_carbon_20y_uplift_potential_per_ha_pct_change',

  permanent_soil_carbon_total_20y_avg_uplift = 'permanent_soil_carbon_total_20y_avg_uplift',
  permanent_soil_carbon_per_ha_20y_avg_uplift = 'permanent_soil_carbon_per_ha_20y_avg_uplift',

  // --------------------------------------- ABOVE GROUND CARBON (CECIL)
  // Historic cecil
  above_ground_carbon_historic_total_graph = 'above_ground_carbon_historic_total_graph',
  above_ground_carbon_historic_per_ha_graph = 'above_ground_carbon_historic_per_ha_graph',

  above_ground_carbon_per_ha_previous_5y_avg_uplift = 'above_ground_carbon_per_ha_previous_5y_avg_uplift ',

  above_ground_carbon_total_previous_1y_uplift = 'above_ground_carbon_total_previous_1y_uplift',
  above_ground_carbon_per_ha_previous_1y_uplift = 'above_ground_carbon_per_ha_previous_1y_uplift',

  above_ground_carbon_per_ha_previous_5y_pct_change = 'above_ground_carbon_per_ha_previous_5y_pct_change',
  above_ground_carbon_per_ha_previous_1y_pct_change = 'above_ground_carbon_per_ha_previous_1y_pct_change',
  above_ground_carbon_total_previous_1y_pct_change = 'above_ground_carbon_total_previous_1y_pct_change',

  canopy_cover_pct_graph = 'canopy_cover_pct_graph',
  canopy_height_graph = 'canopy_height_graph',

  // Current cecil
  above_ground_carbon_per_ha = 'above_ground_carbon_per_ha',
  above_ground_carbon_total = 'above_ground_carbon_total',
  canopy_height = 'canopy_height',
  canopy_cover_pct = 'canopy_cover_pct',

  // Misc cecil
  above_ground_carbon_total_benchmark = 'above_ground_carbon_total_benchmark',
  above_ground_carbon_per_ha_benchmark = 'above_ground_carbon_per_ha_benchmark',

  above_ground_carbon_total_benchmark_graph = 'above_ground_carbon_total_benchmark_graph',
  above_ground_carbon_per_ha_benchmark_graph = 'above_ground_carbon_per_ha_benchmark_graph',

  // --------------------------------------- ABOVE GROUND CARBON (ESA Biomass)
  // Historic
  esa_above_ground_carbon_historic_total_graph = 'esa_above_ground_carbon_historic_total_graph',
  esa_above_ground_carbon_historic_per_ha_graph = 'esa_above_ground_carbon_historic_per_ha_graph',

  esa_above_ground_carbon_total_previous_5y_pct_change = 'esa_above_ground_carbon_total_previous_5y_pct_change',
  esa_above_ground_carbon_total_previous_5y_avg_uplift = 'esa_above_ground_carbon_total_previous_5y_avg_uplift',
  esa_above_ground_carbon_per_ha_previous_5y_avg_uplift = 'esa_above_ground_carbon_per_ha_previous_5y_avg_uplift',

  esa_above_ground_carbon_total_previous_1y_uplift = 'esa_above_ground_carbon_total_previous_1y_uplift',
  esa_above_ground_carbon_per_ha_previous_1y_uplift = 'esa_above_ground_carbon_per_ha_previous_1y_uplift',

  esa_above_ground_carbon_per_ha_previous_5y_pct_change = 'esa_above_ground_carbon_per_ha_previous_5y_pct_change',
  esa_above_ground_carbon_total_previous_1y_pct_change = 'esa_above_ground_carbon_total_previous_1y_pct_change',
  esa_above_ground_carbon_per_ha_previous_1y_pct_change = 'esa_above_ground_carbon_per_ha_previous_1y_pct_change',

  // Current
  esa_above_ground_carbon_per_ha = 'esa_above_ground_carbon_per_ha',
  esa_above_ground_carbon_total = 'esa_above_ground_carbon_total',

  // Misc
  esa_above_ground_carbon_total_benchmark_graph = 'esa_above_ground_carbon_total_benchmark_graph',
  esa_above_ground_carbon_per_ha_benchmark_graph = 'esa_above_ground_carbon_per_ha_benchmark_graph',

  // --------------------------------------- WATER

  // misc
  water_fc_total_benchmark_graph = 'water_fc_total_benchmark_graph',
  water_fc_per_ha_benchmark_graph = 'water_fc_per_ha_benchmark_graph',
  water_fc_per_ha_benchmark = 'water_fc_per_ha_benchmark',
  water_fc_total_benchmark = 'water_fc_total_benchmark',

  // historic
  water_and_soil_moisture_historic_total_graph = 'water_and_soil_moisture_historic_total_graph',
  water_and_soil_moisture_historic_per_ha_graph = 'water_and_soil_moisture_historic_per_ha_graph',

  soil_moisture_smooth_timeseries_per_ha_previous_1y_pct_change = 'soil_moisture_smooth_timeseries_per_ha_previous_1y_pct_change',

  water_fc_previous_1y_uplift_total = 'water_fc_previous_1y_uplift_total',
  water_fc_previous_1y_uplift_per_ha = 'water_fc_previous_1y_uplift_per_ha',

  water_fc_per_ha_previous_5y_uplift = 'water_fc_per_ha_previous_5y_uplift',
  water_fc_per_ha_previous_5y_pct_change = 'water_fc_per_ha_previous_5y_pct_change',

  water_fc_per_ha_previous_1y_pct_change = 'water_fc_per_ha_previous_1y_pct_change',

  water_fc_previous_1y_uplift_total_pct_change = 'water_fc_previous_1y_uplift_total_pct_change',
  water_fc_previous_1y_uplift_per_ha_pct_change = 'water_fc_previous_1y_uplift_per_ha_pct_change',

  water_fc_total_previous_5y_avg_uplift = 'water_fc_total_previous_5y_avg_uplift',
  water_fc_per_ha_previous_5y_avg_uplift = 'water_fc_per_ha_previous_5y_avg_uplift',

  // current
  water_fc_total = 'water_fc_total',
  water_fc_per_ha = 'water_fc_per_ha',

  soil_moisture_smooth_timeseries_total = 'soil_moisture_smooth_timeseries_total',
  soil_moisture_smooth_timeseries_per_ha = 'soil_moisture_smooth_timeseries_per_ha',

  precipitation_trend_change = 'precipitation_trend_change',
  soil_moisture_trend_change = 'soil_moisture_trend_change',

  // projection
  water_fc_increase_1y_uplift_potential_total_change = 'water_fc_increase_1y_uplift_potential_total_change',
  water_fc_increase_1y_uplift_potential_per_ha_change = 'water_fc_increase_1y_uplift_potential_per_ha_change',

  water_fc_increase_1y_uplift_potential_total_pct_change = 'water_fc_increase_1y_uplift_potential_total_pct_change',
  water_fc_increase_1y_uplift_potential_per_ha_pct_change = 'water_fc_increase_1y_uplift_potential_per_ha_pct_change',

  water_fc_increase_5y_uplift_potential_total_change = 'water_fc_increase_5y_uplift_potential_total_change',
  water_fc_increase_5y_uplift_potential_per_ha_change = 'water_fc_increase_5y_uplift_potential_per_ha_change',

  water_fc_increase_5y_uplift_potential_total_pct_change = 'water_fc_increase_5y_uplift_potential_total_pct_change',
  water_fc_increase_5y_uplift_potential_per_ha_pct_change = 'water_fc_increase_5y_uplift_potential_per_ha_pct_change',

  water_fc_total_5y_avg_uplift = 'water_fc_total_5y_avg_uplift',
  water_fc_per_ha_5y_avg_uplift = 'water_fc_per_ha_5y_avg_uplift',

  below_wilting_point_uplift_potential_total_graph = 'below_wilting_point_uplift_potential_total_graph',
  below_wilting_point_uplift_potential_per_ha_graph = 'below_wilting_point_uplift_potential_per_ha_graph',

  water_fc_uplift_potential_total_graph = 'water_fc_uplift_potential_total_graph',
  water_fc_uplift_potential_per_ha_graph = 'water_fc_uplift_potential_per_ha_graph',

  water_fc_increase_10y_uplift_potential_total_change = 'water_fc_increase_10y_uplift_potential_total_change',
  water_fc_increase_10y_uplift_potential_per_ha_change = 'water_fc_increase_10y_uplift_potential_per_ha_change',

  water_fc_increase_10y_uplift_potential_total_pct_change = 'water_fc_increase_10y_uplift_potential_total_pct_change',
  water_fc_increase_10y_uplift_potential_per_ha_pct_change = 'water_fc_increase_10y_uplift_potential_per_ha_pct_change',

  water_fc_total_10y_avg_uplift = 'water_fc_total_10y_avg_uplift',
  water_fc_per_ha_10y_avg_uplift = 'water_fc_per_ha_10y_avg_uplift',

  water_fc_increase_20y_uplift_potential_total_change = 'water_fc_increase_20y_uplift_potential_total_change',
  water_fc_increase_20y_uplift_potential_per_ha_change = 'water_fc_increase_20y_uplift_potential_per_ha_change',

  water_fc_increase_20y_uplift_potential_total_pct_change = 'water_fc_increase_20y_uplift_potential_total_pct_change',
  water_fc_increase_20y_uplift_potential_per_ha_pct_change = 'water_fc_increase_20y_uplift_potential_per_ha_pct_change',

  water_fc_total_20y_avg_uplift = 'water_fc_total_20y_avg_uplift',
  water_fc_per_ha_20y_avg_uplift = 'water_fc_per_ha_20y_avg_uplift',

  // --------------------------------------- SOCIAL
  social_life_expectancy_historic_graph = 'social_life_expectancy_historic_graph',

  // --------------------------------------- POPULATION DENSITY
  // current
  population_density = 'population_density',

  // historic
  population_density_timeseries_graph = 'population_density_timeseries_graph',

  // misc
  population_density_benchmark_graph = 'population_density_benchmark_graph',

  // --------------------------------------- PROTECTED AREAS (IBAT + OSM)´
  // historic
  protected_areas_area = 'protected_areas_area',
  protected_areas_min_distance = 'protected_areas_min_distance',

  // --------------------------------------- THREATED SPECIES
  // historic
  species_presence_aggregated_count = 'species_presence_aggregated_count',
  species_presence_aggregated_count_by_species = 'species_presence_aggregated_count_by_species',

  // --------------------------------------- NDVI
  // current
  vegetation_condition_ndvi = 'vegetation_condition_ndvi',

  // historic
  vegetation_condition_ndvi_historic_graph = 'vegetation_condition_ndvi_historic_graph',
  vegetation_condition_ndvi_previous_1y_uplift = 'vegetation_condition_ndvi_previous_1y_uplift',
  vegetation_condition_ndvi_previous_1y_pct_change = 'vegetation_condition_ndvi_previous_1y_pct_change',

  // misc
  vegetation_condition_ndvi_benchmark_graph = 'vegetation_condition_ndvi_benchmark_graph',

  // --------------------------------------- LAND COVER CHANGE
  // historic
  landcover = 'landcover',
  landcover_by_landscape_type_historic_pct_graph = 'landcover_by_landscape_type_historic_pct_graph',

  // --------------------------------------- ECOSYSTEM CLASSIFICATION
  // 1 - IUCN GET
  // current
  iucn_get_level_1_realm_area = 'iucn_get_level_1_realm_area',
  iucn_get_level_2_biome_area = 'iucn_get_level_2_biome_area',
  iucn_get_level_3_efg_area = 'iucn_get_level_3_efg_area',

  // 2 - RESOLVE
  // current
  resolve_level_1_biome_area = 'resolve_level_1_biome_area',
  resolve_level_2_ecoregion_area = 'resolve_level_2_ecoregion_area',

  // 3 - IUCN HABITATS
  // current
  iucn_habitats_level_1_area = 'iucn_habitats_level_1_area',
  iucn_habitats_level_2_area = 'iucn_habitats_level_2_area',

  // --------------------------------------- HABITAT INTACTNESS
  // current
  habitat_intactness_total = 'habitat_intactness_total',

  threat_breakdown_total = 'threat_breakdown_total',
  threat_breakdown_latest_total = 'threat_breakdown_latest_total',

  threat_areas_pct = 'threat_areas_pct',

  // historic
  habitat_intactness_total_historic_graph = 'habitat_intactness_total_historic_graph',
  habitat_intactness_baseline_total = 'habitat_intactness_baseline_total',
  habitat_intactness_total_previous_5y_pct_change = 'habitat_intactness_total_previous_5y_pct_change',

  threat_breakdown_total_historic_graph = 'threat_breakdown_total_historic_graph',
  threat_breakdown_baseline_total = 'threat_breakdown_baseline_total',
  threat_breakdown_total_previous_5y_pct_change = 'threat_breakdown_total_previous_5y_pct_change',

  threat_areas_historic_graph = 'threat_areas_historic_graph',
  threat_areas_pct_previous_5y_pct_change = 'threat_areas_pct_previous_5y_pct_change',
  threat_breakdown_total_previous_5y_change = 'threat_breakdown_total_previous_5y_change',

  // misc
  habitat_intactness_total_benchmark = 'habitat_intactness_total_benchmark',
  habitat_intactness_geojson_urls = 'habitat_intactness_geojson_urls',

  // --------------------------------------- STRUCTURAL INTEGRITY
  // current
  structural_integrity = 'structural_integrity',
  structural_integrity_score = 'structural_integrity_score',

  // misc
  structural_integrity_benchmark = 'structural_integrity_benchmark',
  structural_integrity_benchmark_graph = 'structural_integrity_benchmark_graph',

  // --------------------------------------- CLEANWAVE (customer facts)
  // misc
  marine_shoot_density = 'marine_shoot_density',
  marine_shoot_density_min = 'marine_shoot_density_min',
  marine_shoot_density_max = 'marine_shoot_density_max',
  marine_seagrass_productivity = 'marine_seagrass_productivity',
  marine_seagrass_productivity_min = 'marine_seagrass_productivity_min',
  marine_seagrass_productivity_max = 'marine_seagrass_productivity_max',
  marine_nursery_habitat = 'marine_nursery_habitat',
  marine_nursery_habitat_min = 'marine_nursery_habitat_min',
  marine_nursery_habitat_max = 'marine_nursery_habitat_max',
  marine_biomass = 'marine_biomass',
  marine_biomass_min = 'marine_biomass_min',
  marine_biomass_max = 'marine_biomass_max',
  marine_diversity = 'marine_diversity',
  marine_diversity_min = 'marine_diversity_min',
  marine_diversity_max = 'marine_diversity_max',
  marine_seaweed_meadows_benchmark_graph = 'marine_seaweed_meadows_benchmark_graph',
  marine_seaweed_meadows_benchmark_text = 'marine_seaweed_meadows_benchmark_text',
  marine_biodiversity_uplift = 'marine_biodiversity_uplift',
  marine_survival_rate_1y = 'marine_survival_rate_1y',
  marine_project_progress = 'marine_project_progress',
  marine_species_density = 'marine_species_density',
  marine_species_density_min = 'marine_species_density_min',
  marine_species_density_max = 'marine_species_density_max',
  marine_multicelular_photosynthetic_organisms = 'marine_multicelular_photosynthetic_organisms',
  marine_multicelular_photosynthetic_organisms_min = 'marine_multicelular_photosynthetic_organisms_min',
  marine_multicelular_photosynthetic_organisms_max = 'marine_multicelular_photosynthetic_organisms_max',
  marine_reproductive_capacity = 'marine_reproductive_capacity',
  marine_reproductive_capacity_min = 'marine_reproductive_capacity_min',
  marine_reproductive_capacity_max = 'marine_reproductive_capacity_max',
  marine_urchin_density = 'marine_urchin_density',
  marine_urchin_density_min = 'marine_urchin_density_min',
  marine_urchin_density_max = 'marine_urchin_density_max',
}

export enum DOMAIN_FACT_TYPES {
  carbon_combined_previous_1y_pct_change = 'carbon_combined_previous_1y_pct_change',
  carbon_combined_per_ha = 'carbon_combined_per_ha',

  water_fc_previous_1y_uplift_per_ha_pct_change = 'water_fc_previous_1y_uplift_per_ha_pct_change',
  water_fc_per_ha = 'water_fc_per_ha',

  biodiversity_buffer_zone_pct = 'biodiversity_buffer_zone_pct',
  biodiversity_buffer_zone_pct_previous_1y_uplift_pct_change = 'biodiversity_buffer_zone_pct_previous_1y_uplift_pct_change',

  permanent_soil_carbon_per_ha = 'permanent_soil_carbon_per_ha',
  permanent_soil_carbon_previous_1y_uplift_per_ha_pct_change = 'permanent_soil_carbon_previous_1y_uplift_per_ha_pct_change',

  social_life_expectancy = 'social_life_expectancy',
  social_life_expectancy_previous_1y_pct_change = 'social_life_expectancy_previous_1y_pct_change',
}

export enum MAP_LAYER_FACTS {
  annual_surface_air_temperature = 'annual_surface_air_temperature',
  annual_precipitation = 'annual_precipitation',
  ocs_0_30cm_mean = 'ocs_0_30cm_mean',
  sand_0_5cm_mean = 'sand_0_5cm_mean',
  cec_0_5cm_mean = 'cec_0_5cm_mean',
  nitrogen_0_5cm_mean = 'nitrogen_0_5cm_mean',
  gbif_species_occurrence = 'gbif_species_occurrence',
  unknown = 'unknown',
  opendata_protected_areas = 'opendata_protected_areas',
  iucn_protected_areas = 'iucn_protected_areas',
  species_presence_occurrence_location_geojson = 'species_presence_occurrence_location_geojson',
  esa_worldcover = 'esa_worldcover',
  habitat_intactness_raster_urls = 'habitat_intactness_raster_urls',
  ecosystem_integrity_index_map_url = 'ecosystem_integrity_index_map_url',
  combined_ibat_lulc_urls = 'combined_ibat_lulc_urls',
  siemens_protected_areas = 'siemens_protected_areas', // TODO: BIG HACK - MVP-7252 - remove once layer is applicable to all organizations
  indicative_lands = 'indicative_lands',
  indigenous_lands = 'indigenous_lands',
  population_density = 'population_density',
  esa_above_ground_carbon_map_url = 'esa_above_ground_carbon_map_url',
  deforestation_map_url = 'deforestation_map_url',
  marine_habitat_map_url = 'marine_habitat_map_url', // manual fact for cleanwave
  marine_operations_map_url = 'marine_operations_map_url', // manual fact for cleanwave
  in_situ_map_layer = 'in_situ_map_layer',
  iucn_get_level_2_biome_raster_asset = 'iucn_get_level_2_biome_raster_asset',
  iucn_get_level_3_efg_raster_asset = 'iucn_get_level_3_efg_raster_asset',
}

export enum CLIMATE_RISK_FACT_TYPES {
  climate_risk_temperature_air_change = 'climate_risk_temperature_air_change',
  // climate_risk_temperature_freshwater_change = 'climate_risk_temperature_freshwater_change',
  // climate_risk_temperature_marine_water_change = 'climate_risk_temperature_marine_water_change',
  climate_risk_heat_stress = 'climate_risk_heat_stress',
  // climate_risk_temperature_variability = 'climate_risk_temperature_variability',
  // climate_risk_permafrost_thawing = 'climate_risk_permafrost_thawing', // do not show - request from Sales
  // climate_risk_heat_wave = 'climate_risk_heat_wave',
  // climate_risk_cold_spell_frost = 'climate_risk_cold_spell_frost',
  climate_risk_wildfire = 'climate_risk_wildfire',
  // climate_risk_wind_patterns_change = 'climate_risk_wind_patterns_change',
  // climate_risk_tropical_cyclone = 'climate_risk_tropical_cyclone',
  climate_risk_storm_wind = 'climate_risk_storm_wind',
  // climate_risk_storm_blizzard = 'climate_risk_storm_blizzard',
  // climate_risk_storm_dust_sandstorm = 'climate_risk_storm_dust_sandstorm',
  // climate_risk_storm_tornado = 'climate_risk_storm_tornado',
  // climate_risk_precipitation_patterns_change = 'climate_risk_precipitation_patterns_change',
  // climate_risk_precipitation_variability = 'climate_risk_precipitation_variability',
  // climate_risk_ocean_acidification = 'climate_risk_ocean_acidification',
  // climate_risk_saline_intrusion = 'climate_risk_saline_intrusion',
  // climate_risk_sea_level_rise = 'climate_risk_sea_level_rise',
  // climate_risk_water_stress = 'climate_risk_water_stress',
  climate_risk_drought = 'climate_risk_drought',
  climate_risk_heavy_precipitation = 'climate_risk_heavy_precipitation',
  // climate_risk_heavy_precipitation_types = 'climate_risk_heavy_precipitation_types',
  climate_risk_coastal_flood = 'climate_risk_coastal_flood',
  climate_risk_fluvial_flood = 'climate_risk_fluvial_flood',
  // climate_risk_pluvial_groundwater_flood = 'climate_risk_pluvial_groundwater_flood',
  // climate_risk_glacial_lake_outburst = 'climate_risk_glacial_lake_outburst',
  // climate_risk_coastal_erosion = 'climate_risk_coastal_erosion',
  // climate_risk_soil_degradation = 'climate_risk_soil_degradation',
  // climate_risk_soil_erosion = 'climate_risk_soil_erosion',
  // climate_risk_solifluction = 'climate_risk_solifluction',
  // climate_risk_avalanche = 'climate_risk_avalanche',
  // climate_risk_landslide = 'climate_risk_landslide',
  // climate_risk_subsidence = 'climate_risk_subsidence',
}

export const REPORTING_FACT_BENCHMARKS = [
  IndicatorName.permanent_soil_carbon_per_ha_benchmark,
  IndicatorName.permanent_soil_carbon_total_benchmark,
  IndicatorName.water_fc_per_ha_benchmark,
  IndicatorName.water_fc_total_benchmark,
] as IndicatorFactType[];

export const POTENTIAL_FACT_TYPES = [
  IndicatorName.permanent_soil_carbon_1y_uplift_potential_total_change,
  IndicatorName.permanent_soil_carbon_1y_uplift_potential_per_ha_change,
  IndicatorName.permanent_soil_carbon_5y_uplift_potential_total_change,
  IndicatorName.permanent_soil_carbon_5y_uplift_potential_per_ha_change,
  IndicatorName.permanent_soil_carbon_10y_uplift_potential_total_change,
  IndicatorName.permanent_soil_carbon_10y_uplift_potential_per_ha_change,
  IndicatorName.permanent_soil_carbon_20y_uplift_potential_total_change,
  IndicatorName.permanent_soil_carbon_20y_uplift_potential_per_ha_change,

  IndicatorName.water_fc_increase_1y_uplift_potential_total_change,
  IndicatorName.water_fc_increase_1y_uplift_potential_per_ha_change,
  IndicatorName.water_fc_increase_10y_uplift_potential_total_change,
  IndicatorName.water_fc_increase_10y_uplift_potential_per_ha_change,
] as IndicatorFactType[];

export const SIGNED_FACT_TYPES = [
  IndicatorName.biodiversity_buffer_zone_pct_previous_1y_uplift_change,

  IndicatorName.lst_previous_1y_uplift,
  IndicatorName.lst_previous_1y_pct_change,

  IndicatorName.above_ground_carbon_total_previous_1y_uplift,
  IndicatorName.above_ground_carbon_per_ha_previous_1y_uplift,
  IndicatorName.above_ground_carbon_total_previous_1y_pct_change,
  IndicatorName.above_ground_carbon_per_ha_previous_1y_pct_change,

  IndicatorName.permanent_soil_carbon_previous_1y_uplift_total,
  IndicatorName.permanent_soil_carbon_previous_1y_uplift_per_ha,
  IndicatorName.permanent_soil_carbon_previous_1y_uplift_total_pct_change,
  IndicatorName.permanent_soil_carbon_previous_1y_uplift_per_ha_pct_change,
  IndicatorName.permanent_soil_carbon_total_previous_5y_avg_uplift,
  IndicatorName.permanent_soil_carbon_per_ha_previous_5y_avg_uplift,
  IndicatorName.permanent_soil_carbon_1y_uplift_potential_total_change,
  IndicatorName.permanent_soil_carbon_1y_uplift_potential_per_ha_change,
  IndicatorName.permanent_soil_carbon_1y_uplift_potential_total_pct_change,
  IndicatorName.permanent_soil_carbon_1y_uplift_potential_per_ha_pct_change,
  IndicatorName.permanent_soil_carbon_5y_uplift_potential_total_change,
  IndicatorName.permanent_soil_carbon_5y_uplift_potential_per_ha_change,
  IndicatorName.permanent_soil_carbon_5y_uplift_potential_total_pct_change,
  IndicatorName.permanent_soil_carbon_5y_uplift_potential_per_ha_pct_change,
  IndicatorName.permanent_soil_carbon_total_5y_avg_uplift,
  IndicatorName.permanent_soil_carbon_per_ha_5y_avg_uplift,
  IndicatorName.permanent_soil_carbon_10y_uplift_potential_total_change,
  IndicatorName.permanent_soil_carbon_10y_uplift_potential_per_ha_change,
  IndicatorName.permanent_soil_carbon_10y_uplift_potential_total_pct_change,
  IndicatorName.permanent_soil_carbon_10y_uplift_potential_per_ha_pct_change,
  IndicatorName.permanent_soil_carbon_total_10y_avg_uplift,
  IndicatorName.permanent_soil_carbon_per_ha_10y_avg_uplift,
  IndicatorName.permanent_soil_carbon_20y_uplift_potential_total_change,
  IndicatorName.permanent_soil_carbon_20y_uplift_potential_per_ha_change,
  IndicatorName.permanent_soil_carbon_20y_uplift_potential_total_pct_change,
  IndicatorName.permanent_soil_carbon_20y_uplift_potential_per_ha_pct_change,
  IndicatorName.permanent_soil_carbon_total_20y_avg_uplift,
  IndicatorName.permanent_soil_carbon_per_ha_20y_avg_uplift,

  IndicatorName.soil_moisture_trend_change,
  IndicatorName.precipitation_trend_change,
  IndicatorName.water_fc_previous_1y_uplift_total,
  IndicatorName.water_fc_previous_1y_uplift_per_ha,
  IndicatorName.water_fc_total_previous_5y_avg_uplift,
  IndicatorName.water_fc_per_ha_previous_5y_avg_uplift,
  IndicatorName.water_fc_previous_1y_uplift_total_pct_change,
  IndicatorName.water_fc_previous_1y_uplift_per_ha_pct_change,
  IndicatorName.water_fc_increase_1y_uplift_potential_total_change,
  IndicatorName.water_fc_increase_1y_uplift_potential_per_ha_change,
  IndicatorName.water_fc_increase_1y_uplift_potential_total_pct_change,
  IndicatorName.water_fc_increase_1y_uplift_potential_per_ha_pct_change,
  IndicatorName.water_fc_increase_5y_uplift_potential_total_change,
  IndicatorName.water_fc_increase_5y_uplift_potential_per_ha_change,
  IndicatorName.water_fc_increase_5y_uplift_potential_total_pct_change,
  IndicatorName.water_fc_increase_5y_uplift_potential_per_ha_pct_change,
  IndicatorName.water_fc_total_5y_avg_uplift,
  IndicatorName.water_fc_per_ha_5y_avg_uplift,
  IndicatorName.water_fc_increase_10y_uplift_potential_total_change,
  IndicatorName.water_fc_increase_10y_uplift_potential_per_ha_change,
  IndicatorName.water_fc_increase_10y_uplift_potential_total_pct_change,
  IndicatorName.water_fc_increase_10y_uplift_potential_per_ha_pct_change,
  IndicatorName.water_fc_total_10y_avg_uplift,
  IndicatorName.water_fc_per_ha_10y_avg_uplift,
  IndicatorName.water_fc_increase_20y_uplift_potential_total_change,
  IndicatorName.water_fc_increase_20y_uplift_potential_per_ha_change,
  IndicatorName.water_fc_increase_20y_uplift_potential_total_pct_change,
  IndicatorName.water_fc_increase_20y_uplift_potential_per_ha_pct_change,
  IndicatorName.water_fc_total_20y_avg_uplift,
  IndicatorName.water_fc_per_ha_20y_avg_uplift,

  IndicatorName.water_fc_per_ha_previous_5y_pct_change,
  IndicatorName.above_ground_carbon_per_ha_previous_5y_pct_change,
  IndicatorName.biodiversity_buffer_zone_pct_previous_5y_pct_change,
  IndicatorName.permanent_soil_carbon_per_ha_previous_5y_pct_change,

  IndicatorName.social_life_expectancy,
  IndicatorName.social_life_expectancy_previous_1y_pct_change,
  IndicatorName.biodiversity_buffer_zone_pct_previous_1y_pct_change,
  IndicatorName.deforestation_previous_1y_pct_change,
  IndicatorName.above_ground_carbon_per_ha_previous_1y_pct_change,
  IndicatorName.water_fc_per_ha_previous_1y_pct_change,
  IndicatorName.soil_moisture_smooth_timeseries_per_ha_previous_1y_pct_change,
] as IndicatorFactType[];

export const LANDSCAPE_VIEW_FACTS: readonly IndicatorFactType[] = [
  // Protected areas (IBAT + OSM)
  IndicatorName.protected_areas_area,
  IndicatorName.protected_areas_min_distance,

  // Threatened species
  IndicatorName.species_presence_aggregated_count,
  IndicatorName.species_presence_aggregated_count_by_species,

  // Landcover change
  IndicatorName.landcover_by_landscape_type_historic_pct_graph,

  // Maps
  MAP_LAYER_FACTS.species_presence_occurrence_location_geojson,
  MAP_LAYER_FACTS.opendata_protected_areas,
  MAP_LAYER_FACTS.iucn_protected_areas,
  MAP_LAYER_FACTS.esa_worldcover,
  MAP_LAYER_FACTS.combined_ibat_lulc_urls,
  // TODO: BIG HACK - MVP-7252 - remove once layer is applicable to all organizations
  MAP_LAYER_FACTS.siemens_protected_areas,
] as const;

export enum BenchmarkType {
  unchanged = 'unchanged',
  very_low = 'very_low',
  low = 'low',
  moderate = 'moderate',
  high = 'high',
  very_high = 'very_high',
  stable = 'stable',
  alerted = 'alerted',
}

export enum LandUse {
  cultivated = 'cultivated',
  paddy = 'paddy',
  perennial = 'perennial',
  set_aside = 'set_aside',
  native = 'native',
}

export enum CarbonInput {
  high_c_input_without_manure = 'high_c_input_without_manure',
  high_c_input_with_manure = 'high_c_input_with_manure',
  medium_c_input = 'medium_c_input',
  low_c_input = 'low_c_input',
}

export enum Tillage {
  full = 'full',
  reduced = 'reduced',
  no_till = 'no_till',
}

export enum Scenario {
  baseline = 'baseline',
  best = 'best',
  moderate = 'moderate',
  worst = 'worst',
}

export enum ClimateRiskRating {
  not_relevant = 'not_relevant',
  very_low = 'very_low',
  low = 'low',
  medium = 'medium',
  high = 'high',
  very_high = 'very_high',
}

export enum LandscapeType {
  tree_cover = 'tree_cover',
  built_up = 'built_up',
  cropland = 'cropland',
  grassland = 'grassland',
  bareground = 'bareground',
  herbaceous_wetland = 'herbaceous_wetland',
  shrubland = 'shrubland',
  permanent_water_bodies = 'permanent_water_bodies',
  snow_and_ice = 'snow_and_ice',
}

export enum ClimateRiskRatingOrder {
  not_relevant = 0,
  very_low = 1,
  low = 2,
  medium = 3,
  high = 4,
  very_high = 5,
}

export enum ThreatType {
  no_threat_area = 'no_threat_area',
  cropland = 'cropland',
  deforestation = 'deforestation',
  builtup = 'builtup',
  roads = 'roads',
}

export const THREAT_TYPES = Object.values(ThreatType);
export const HABITAT_INTACTNESS_KEY = 'habitat_intactness';

export type HabitatIntactnessAndThreats = ThreatType | typeof HABITAT_INTACTNESS_KEY;

export type LayerMetadata = {
  asset_id: string;
  provenance: {
    source_dataset: string;
    source_year: number;
  };
  storage_uri: string;
  map_url: string;
};
export type RasterLayerYear = `20${number}`;

export type LayerFactValue = Partial<Record<HabitatIntactnessAndThreats, Record<RasterLayerYear, LayerMetadata>>>;
export type MapRastersFact = PlotReportFactElement<LayerFactValue>;

export const ClimateRiskRatingsByIndex = ['not_relevant', 'very_low', 'low', 'medium', 'high', 'very_high'];

export enum ConservationBenchmark {
  pristine = 'pristine',
  good = 'good',
  fair = 'fair',
  poor = 'poor',
  critical = 'critical',
}

export enum DeforestationCategory {
  forest_loss = 'forest_loss',
  no_loss_detected = 'no_loss_detected',
}

export enum SpeciesEnum {
  posidonia = 'posidonia',
  cystoseira = 'cystoseira',
}

export enum MarineFunctionalGroupEnum {
  macroinvertebrate = 'macroinvertebrate',
  fish = 'fish',
}

export enum PopulationDensityBenchmark {
  urban_center = 'urban_center',
  urban_cluster = 'urban_cluster',
  rural = 'rural',
}

export enum EcosystemType {
  marine = 'marine',
  terrestrial = 'terrestrial',
}

export enum PlotReportFactLabelNameEnum {
  benchmark = 'benchmark',
  benchmark_conservation = 'benchmark_conservation',
  benchmark_population_density = 'benchmark_population_density',
  deforestation = 'deforestation',
  uncertainty = 'uncertainty',
  carbon_input = 'carbon_input',
  tillage = 'tillage',
  land_use = 'land_use',
  value_class = 'value_class',
  scenario = 'scenario',
  landscape_radius = 'landscape_radius',
  landscape_radius_m = 'landscape_radius_m', // use only for querying facts data
  protection_category = 'protection_category',
  kingdom = 'kingdom',
  iucn_redlist_category = 'iucn_redlist_category',
  species = 'species',
  landscape_type = 'landscape_type',
  threat_type = 'threat_type',
  functional_group = 'functional_group',
  ecosystem_type = 'ecosystem_type',
  class_name = 'class_name',
  statistic = 'statistic',
  deforestation_driver_type = 'deforestation_driver_type',
  deforestation_driver = 'deforestation_driver',
  common_name = 'common_name',
}

export enum DegradationDriverType {
  dominant = 'dominant',
  secondary = 'secondary',
}

export enum DegradationDriver {
  permanent_agriculture = 'permanent_agriculture',
  hard_commodities = 'hard_commodities',
  shifting_cultivation = 'shifting_cultivation',
  logging = 'logging',
  wildfire = 'wildfire',
  settlements_and_infrastructure = 'settlements_and_infrastructure',
  other_natural_disturbances = 'other_natural_disturbances',
  no_forest_loss = 'no_forest_loss',
  no_data = 'no_data',
}

export enum ValueClass {
  interpolated = 'interpolated',
  valid_estimate = 'valid_estimate',
  interpolation_not_possible = 'interpolation_not_possible',
}

export type PlotReportFactLabelFilter = Partial<Record<string, string>>;

export type PlotReportFactLabel<T = number | string | null | unknown> = {
  name: string;
  value: T;
};

export type PlotReportFactElement<T = number | string | null | unknown> = {
  name: IndicatorFactType;
  value: T;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata?: Record<string, any>;
  upper_confidence_limit: T;
  lower_confidence_limit: T;
  unit: UnitEnum;
  measured_at: string | null;
  date?: string | null;
  previous_1y_measured_at: string | null;
  labels: PlotReportFactLabel[];
};

export const LABEL_FILTERS = {
  ALL: '*',
} as const;

export const FACT_AGGREATION_METHOD = {
  SUM: 'sum',
  WEIGHTED_AVG: 'weighted_avg',
} as const;
